import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PATH_ADMIN_USER_ADD, PATH_ADMIN_USER_EDIT } from 'routing/path'
import PageHeader from 'components/page-header'
import Table from 'components/table'
import { useGetUsersQuery } from 'actions/admin-user-api';
import { translationApi  } from 'actions/translation-api';

const UserList = () => {
	const { data: userList } = useGetUsersQuery(null, { refetchOnMountOrArgChange: true });
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const headers = [translations.lastName, translations.firstName, translations.login, translations.email, translations.phone, translations.lastLoginDate];
	let rows = [];
	if (userList && userList.users) {
		rows = userList.users.map(function (user) {
			return {
				link: PATH_ADMIN_USER_EDIT + user.login,
				columns: [user.lastName, user.firstName, user.login, user.email, user.phone, user.lastLoginDate]
			}
		});
	}
	const buttons = [<Link id="addUserButton" key="addUserButton" className="btn btn-primary me-2" to={PATH_ADMIN_USER_ADD}>{translations.actionAddUser}</Link>];

	return (
		<div>
			<PageHeader title={translations.userList} buttons={buttons} breadcrumbs={[]} breadcrumbsCurrentPage={translations.userList} />
			<Table headers={headers} rows={rows} />
		</div>
	);
}

export default UserList;
